import { Component } from 'react'
import * as isNumber from 'lodash/isNumber'
import { CreditscorePageType } from 'interfaces/pages'
import { CreditAccount } from 'interfaces/credit'
import { AccountType, DetailedAccount, RatedAccount } from 'interfaces/accounts'
import {
  ASSETS_COMPETITIVE_RATE,
  ASSETS_NON_COMPETITIVE_FEES,
  ASSETS_NON_COMPETITIVE_RATE,
  DEBTS_COMPETITIVE_RATE,
  DEBTS_NON_COMPETITIVE_RATE,
  NO_EFFECTIVE_RATE,
  PROVIDER_ERROR,
} from 'constants/hints'
import { TooltipIcon } from 'components/features/pfm/Tooltip/TooltipIcon'
import { CATEGORIES_WITHOUT_EFFECTIVE_RATE } from 'constants/accounts'
import { isFeeBased, isRatedAccount } from 'helpers/accountHelpers'

type CreditAccountTooltipProps = {
  type: CreditscorePageType
  account: CreditAccount
}

type DebtsAssetsAccountTooltipProps = {
  type: AccountType
  account: RatedAccount | DetailedAccount
}

export type AccountTooltipProps =
  | DebtsAssetsAccountTooltipProps
  | CreditAccountTooltipProps

class AccountTooltip extends Component<AccountTooltipProps> {
  private get tooltipCopy () {
    const { type, account } = this.props

    if (!isRatedAccount(account) || account.is_manual) {
      return null
    }

    const { rateObj, category } = account
    const { is_competitive } = rateObj

    const isDebts = type === 'debts'

    if (is_competitive) {
      return isDebts ? DEBTS_COMPETITIVE_RATE : ASSETS_COMPETITIVE_RATE
    }

    if (isDebts) {
      return DEBTS_NON_COMPETITIVE_RATE
    }

    return isFeeBased(category.id) ? ASSETS_NON_COMPETITIVE_FEES : ASSETS_NON_COMPETITIVE_RATE
  }

  render () {
    const { account } = this.props

    if (!isRatedAccount(account) || account.is_manual) {
      return null
    }

    const { link_status, category } = account

    const {
      opportunity,
      effective_rate,
    } = account.rateObj

    if (isNumber(opportunity) && opportunity > 0) {
      return (
        <TooltipIcon theme='danger'>
          { this.tooltipCopy }
        </TooltipIcon>
      )
    }

    const isNotEffectiveRateAvailable = effective_rate === null && !CATEGORIES_WITHOUT_EFFECTIVE_RATE.has(category.id)
    if (link_status === 'inactive' || isNotEffectiveRateAvailable) {
      return (
        <TooltipIcon theme='warning'>
          { link_status === 'inactive' ? PROVIDER_ERROR : NO_EFFECTIVE_RATE }
        </TooltipIcon>
      )
    }

    return null
  }
}

export default AccountTooltip
